import React, { FunctionComponent, useState } from 'react';
import { ImagoImagesList } from './ImagoImagesList';
import { Grid, Input, InputAdornment, LinearProgress } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Cancel';
import { withDataProvider, translate, useNotify } from 'react-admin';
import { DataProvider } from 'ra-core';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';

interface DispatchProps {
  dataProvider?: DataProvider;
  handleOpen;
  galleryId;
  videoId;
  eventstreamId: string | null;
  handleEventstream: CallableFunction
}

export const ImagoUpload: FunctionComponent<DispatchProps> = translate(
    withDataProvider(
        ({ dataProvider, handleOpen, translate, galleryId, videoId, eventstreamId, handleEventstream }) => {
            const [keyword, setKeyword] = useState('');
            const [resultCount, setResultCount] = useState(0);
            const [isDownloadingImage, setIsDownloadingImage] = useState(false);

            const handleChangeKeyword = (keyword: string) => {
                setResultCount(0);
                setKeyword(keyword);
            };

            const dispatch = useDispatch();
            const notify = useNotify();

            const handlePickImage = (imageId: string, db: string) => {
                setIsDownloadingImage(true);
                dataProvider(
                    'UPLOAD',
                    'imago',
                    { id: imageId, db: db },
                    {
                        onSuccess: {
                            notification: {
                                body: 'resources.getty.notification.image_uploaded',
                                info: 'info'
                            }
                        }
                    }
                )
                    .then(response => {
                        setIsDownloadingImage(false);
                        if (galleryId) {
                            dataProvider('ADD_ASSETS', 'gallery', {
                                galleryId: galleryId,
                                assetIds: [response.data.id]
                            })
                                .then(response => {
                                    notify('resources.gallery.notification.assets_added');
                                    handleOpen(false);
                                    window.location.reload();
                                })
                                .catch(error => {
                                    notify(error.message, 'warning');
                                });
                        } else if (videoId) {
                            dataProvider('UPDATE_THUMBNAIL', 'video', { id: videoId, assetID: response.data.id })
                                .then(response => {
                                    notify('resources.gallery.notification.assets_added');
                                    handleOpen(false);
                                    window.location.reload();
                                })
                                .catch(error => {
                                    notify(error.message, 'warning');
                                });
                        } else if (eventstreamId) {
                            dataProvider('GET_TRANSFORMATION_LIST', 'asset', {id: response.data.id})
                                .then(response => {
                                    handleEventstream(response.data[0].id);
                                    handleOpen(false);
                                })
                                .catch(error => {
                                    notify(error.message, 'warning');
                                });
                        } else {
                            dispatch(push(`/asset/${response.data.id}`));
                            handleOpen(false);
                        }
                    })
                    .catch(error => {
                        setIsDownloadingImage(false);
                        notify('resources.asset.notification.image_uploaded_failed', 'warning');
                    });
            };

            return (
                <>
                    <Grid container spacing={1} style={{ padding: 24 }}>
                        <Grid item style={{ textAlign: 'center' }} xs>
                            <Input
                                autoFocus={true}
                                id="adornment-password"
                                type="text"
                                value={keyword}
                                onChange={e => handleChangeKeyword(e.target.value)}
                                placeholder=""
                                endAdornment={
                                    <InputAdornment position="end">
                                        <ClearIcon
                                            onClick={() => {
                                                handleChangeKeyword('');
                                            }}
                                            aria-label="Imago Search"
                                        >
                                            {' '}
                                        </ClearIcon>
                                    </InputAdornment>
                                }
                            />
              &nbsp;{' '}
                            {resultCount > 0 &&
                translate('mam.found', { count: resultCount.toLocaleString() })}
                        </Grid>
                    </Grid>
                    <ImagoImagesList
                        keyword={keyword}
                        handlePickImage={handlePickImage}
                        handleResultCount={setResultCount}
                    />
                    {isDownloadingImage && <LinearProgress color="secondary" />}
                </>
            );
        }
    )
);
